<h2 mat-dialog-title class="dialog-title">
  <mat-icon class="dialog-title-icon">send</mat-icon>
  Select Target &amp; Send
</h2>

<mat-dialog-content class="dialog-content">
  <div *ngIf="isLoadingModalities" class="loading-state">
    <mat-progress-spinner diameter="32"></mat-progress-spinner>
    <span>Loading facilities…</span>
  </div>

  <ng-container *ngIf="!isLoadingModalities">
    <app-patients-actions-facility
      [facilities]="facilities"
      [selectedFacility]="selectedFacilityAsSharingPatientId"
      (facilitySelected)="onFacilitySelected($event)">
    </app-patients-actions-facility>

    <!-- Modality selector — only shown when > 1 modality matches the facility -->
    <div *ngIf="selectedFacility && facilityModalities.length > 1" class="modality-section">
      <label class="modality-label">Modality</label>
      <mat-form-field appearance="outline" class="modality-field">
        <mat-select [(ngModel)]="selectedModality" placeholder="Select modality">
          <mat-option *ngFor="let m of facilityModalities" [value]="m">{{ m.name }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div *ngIf="selectedFacility && facilityModalities.length === 0" class="no-modality-warning">
      <mat-icon>warning</mat-icon>
      No DICOM modality is configured for this facility.
    </div>
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button
    mat-raised-button
    color="primary"
    [disabled]="!canSend"
    (click)="onSend()">
    <mat-icon>send</mat-icon>
    Send
  </button>
</mat-dialog-actions>
